<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="出库单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 出库单号:{{ form.no }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 发起人:{{ form.createdUserName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 所属科室:{{ form.ownerDeptName }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="purchaseApplyNo" label="请领单" v-if="getIsView()">
                <el-select v-model="form.purchaseApplyNo" :disabled="!editMode||isPicking||system_setting.IsPickOutbound" placeholder="请选择" filterable
                  :filter-method="getPurchaseList" @change="purchaseChange" style="width:100%">
                  <el-option v-for="item in purchaseList" :key="item.id" :label="item.no + ' ' + item.applyDeptName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 请领单:{{ form.purchaseApplyNo }}</span>
            </el-col>
            <el-col :span="4" v-if="system_setting.IsPickOutbound" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="pickingStockNo" label="拣货单号" v-if="getIsView()">
                   <el-input disabled v-model="form.pickingStockNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 拣货单号:{{ form.pickingStockNo }}</span>
            </el-col>
            <el-col :span="5" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyDeptName" label="请领科室" v-if="getIsView()">
                <el-select v-if="system_setting.IsUseWard" v-model="form.applyDeptName" placeholder="请选择"
                  :disabled="!form.purchaseApplyNo == false || !editMode ||isPicking" style="width: 100%" filterable
                  :filter-method="getDeptAndWards1" @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards1" :key="item.idGroup"
                    :label="item.deptNo+' '+ item.deptName + ' ' + (item.wardName ? item.wardName : '')"
                    :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.applyDeptName" placeholder="请选择"
                  :disabled="!form.purchaseApplyNo == false || !editMode ||isPicking" style="width: 100%" filterable
                  :filter-method="getDepts" @change="applyDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 请领科室:{{ form.applyDeptName }}</span>
            </el-col>
            <el-col :span="5" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="出库仓库" v-if="getIsView()">
                <el-select @change="warehouseChange" v-model="form.warehouseName " :disabled="!editMode ||isPicking"
                  placeholder="请选择" filterable :filter-method="getOneLevelWarehousesBySessionWarehouseId"
                  style="width:100%">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 出库仓库:{{ form.warehouseName }}</span>
            </el-col>
            <el-col :span="5" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseManagerName" label="库管员" v-if="getIsView()">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 库管员:{{ form.warehouseManagerName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="出库类型" v-if="getIsView()">
                <el-radio-group :disabled="!editMode ||isPicking" v-model="form.category">
                  <el-radio v-for="item in StockCategoryOptions" :key="item.id" :label="item.id">{{ item.name
                    }}出库</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else> 出库类型:{{ form.category }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="outStockCategoryName" label="出库性质" v-if="getIsView()">
                <SelectTree :disabled="!editMode ||isPicking" @handleCheckChange="handleCheckChange" :defaultProps="defaultProps"
                  :data="STATIC_OutStockCategorys" :defaultValue="form.outStockCategoryName" style="width:100%">
                </SelectTree>
              </el-form-item>
              <span class="viewText" v-else> 出库性质:{{ form.outStockCategoryName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-input disabled v-model="form.patientNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientName" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 患者姓名:{{ form.patientName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="医生姓名" v-if="getIsView()">
                <el-input disabled v-model="form.doctorName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 医生姓名:{{ form.doctorName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorNo" label="医生工号" v-if="getIsView()">
                <el-input disabled v-model="form.doctorNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 医生工号:{{ form.doctorNo }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="计费科室" prop="chargeDeptName" v-if="getIsView()">
                <el-input disabled v-model="form.chargeDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 计费科室:{{ form.chargeDeptName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 备注:{{ form.remark }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="实际领用人" prop="useUserName" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="实际领用人" v-model="form.useUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 实际领用人:{{ form.useUserName }}</span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="配送点" prop="useUserName" v-if="getIsView()">
                <el-input disabled placeholder="配送点" v-model="form.distributionPoint"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 配送点:{{ form.distributionPoint }}</span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">请领明细</span>
          </div>
          <el-table ref="childTable1" border :data="applyDetails" style="width: auto; margin: 0 10px" stripe
            :header-cell-style="{ background: '#DDEBFF' }" @selection-change="selectApplyDetail">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" fixed label="产品" width="180" />
            <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="120" />

            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column prop="isScanName" label="是否扫码" width="80" />
            <el-table-column prop="packSpec" label="包装规格" width="120" />
            <el-table-column prop="minUnit" label="最小单位" width="80" />
            <el-table-column prop="stockNumber" label="科室库存" width="100" />
            <el-table-column prop="oneLevelStockNumber" label="一级库库存" width="100" />
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="140" />
            <el-table-column prop="number" label="申请数量" width="80" />
            <el-table-column prop="notReceivedNumber" label="未领数量" width="80" />
            <el-table-column prop="price" label="单价" width="100" />
            <el-table-column prop="amount" label="小计" width="100" />
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" />
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
              
          </el-table>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">出库明细</span>
          </div>

          <div v-if="editMode && !isPicking" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
            <el-button  class="btn primary" type="primary" style="margin-left:20px"
            @click="showTransfer">自定义设置</el-button>
          </div>
          <div v-else style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-if="form.status==1" v-preventReClick @click="packCodeEvt">动态打包</el-button>
            <el-button v-if="!isPicking" class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          </div>

          <div v-if="tableHaeder.length>0">
            <CustomTable  ref="customTable" :tableData="form.details" @handleSelectionChange="handleChildSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
            :tableHeight="tableHeight"  :tableCode="route.name" :cellDblclick="cellDblclick"> 
              <template slot="before">
                <el-table-column type="index" width="50" fixed> </el-table-column>
                <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
              </template>
              <template slot="after">
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" v-if="this.system_setting.costAccountingType == 0"
                label="移库单详细" width="150">
                <template slot-scope="scope">
                  <el-button type="text" v-preventReClick @click="handleMoveLiBrayInfo(scope.row)"
                    class="color-blue">查看详情</el-button>
                </template>
              </el-table-column>
              </template>
            </CustomTable>
          </div>
          <div v-else>
            <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="120" fixed></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column> -->

            <el-table-column prop="isScanName" label="是否扫码" width="80" />
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="140"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="140"></el-table-column>
            <el-table-column prop="number" label="数量" width="120"></el-table-column>
            <el-table-column prop="inStockNumber" label="入库数量" width="120"></el-table-column>
            <el-table-column prop="refundNumber" label="退库数量" width="120"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="120">
            </el-table-column>
            <el-table-column prop="locationName" label="货位" width="180">
            </el-table-column>
            <el-table-column prop="batch" label="批次号" width="120">
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{ scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"> </el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"
              width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
              <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            <el-table-column fixed="right" prop="operation" v-if="this.system_setting.costAccountingType == 0"
              label="移库单详细" width="150">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleMoveLiBrayInfo(scope.row)"
                  class="color-blue">查看详情</el-button>

              </template>
            </el-table-column>
          </el-table>
          </div>
      
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px"
        :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no"
                  @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="applyOutStockColumns1"
                  :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList"
                  @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="isScanName" label="是否扫码">
                <el-input disabled v-model="childForm.isScanName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable
                  @change="childLocationChange" style="width:100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.manufactureDate" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期"
                  style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker :disabled="!editMode || Boolean(childForm.longTime)" v-model="childForm.validityDate"
                  size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期"
                  style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" :disabled="!editMode" @change="longTimeChange(childForm)"
                  active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input :disabled="!editMode" placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input :disabled="!editMode" placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number"
                  :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="newProductId" label="产品ID">
                <el-input disabled v-model="childForm.newProductId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productCode" label="商品代码">
                <el-input disabled v-model="childForm.productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newOnlineNo" label="新挂网号">
                <el-input disabled v-model="childForm.newOnlineNo"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick
            @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确
            定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="goBack">{{!isPicking?'返回请领单列表':'返回拣货单列表'}}</el-button>
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂
        存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>

    </div>


    <MoveLibrayTable ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle"
      @close="closeSelectDialog" :tipColumOptions="tipColumOptions" :columOptions="columnOptions"
      :dataList="movelibrayList">查看</MoveLibrayTable>
    <LabelPackDialog  v-if="labelPackVisible" :open="labelPackVisible" 
    @close="closeLabelPackDialog"
    :toBePackagedData="toBePackagedData"
    :packagedData="packagedData"
    @getTableData="getTableData"
    />

    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>

    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import ScanMixin from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetApplyOutStockById,
  SaveApplyOutStock,
  RejectApplyOutStock,
  GetPurchaseApplys,
  GetPurchaseApplyById,
  GetStockViewModelsByApplyId,
  GetMoveLibraryByDetailId,
  GetApplyOutStocks,
  GetPurchasePlans,
  CheckIsHavePurchasePlans,
  GetWarehousesByDeptId,
  GetWarehousesByDeptIdAndWard,
  GetUnPackedTagCodeDetailsInApplyOut,
  GetPackedTagCodeDetailsInApplyOut,
  GetAcceptInStockById,
  GetPurchaseDistributionById,
  GetSupplierProductById,
  GetPickingStockById,
  SaveApplyOutStockTemp
} from "@/api";
import {
  StockCategoryOptions
} from "@/enum";
import SelectTable from "@/components/select-table";
import SelectTree from '@/components/select-tree'
import ApproveInfo from "@/components/approve-info";
import MoveLibrayTable from "@/components/move-libray-table";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import LabelPackDialog from "@/components/labelPack-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, ScanMixin,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SelectTree,
    MoveLibrayTable,
    LabelDetailsDialog,
    LabelPackDialog,
    PackageLabelDialog
  },
  data () {
    return {
      form: {},
      GetDataAction: GetApplyOutStockById,
      SaveDataAction: SaveApplyOutStock,
      reject: RejectApplyOutStock,
      GetMoveLibraryByDetailId: GetMoveLibraryByDetailId,
      StockCategoryOptions: StockCategoryOptions,
      toBePackagedApi:GetUnPackedTagCodeDetailsInApplyOut,
      packagedApi:GetPackedTagCodeDetailsInApplyOut,
      SaveTempAction: SaveApplyOutStockTemp,
      rules: {
        warehouseName: [{
          required: true,
          message: "请选择出库仓库",
          trigger: "blur"
        },],
        date: [{
          required: true,
          message: "请选择出库日期",
          trigger: "blur"
        }],
        category: [{
          required: true,
          message: "请选择出库类型",
          trigger: "blur"
        },],
        supplierName: [{
          required: true,
          message: "请选择供应商",
          trigger: "blur"
        },],
        applyDeptName: [{
          required: true,
          message: "请选择请领科室",
          trigger: "blur"
        },]
        // remark: [
        //   { required: true, message: "请选择退货理由", trigger: "blur" },
        // ],
      },
      childFormRules: {
        // manufactureDate: [
        //   { required: true, message: "请选择生产日期", trigger: "blur" },
        //   { validator: this.validateManufacturerDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        // validityDate: [
        //   { required: true, message: "请选择有效期", trigger: "blur" },
        //   { validator: this.validateValidityDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        productName: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur"
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur"
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      showSelectDialog: false,
      isScan: false,
      selectDialogTitle: '移库详情',
      purchaseList: [],
      selectApplyArr: [],
      applyDetails: [],
      movelibrayList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      tipColumOptions: [],
      columnOptions: [{
        label: "移库单号",
        key: "no",
        width: 140
      },
      {
        label: "仓库",
        key: "warehouseName",
        width: 100
      },
      {
        label: "领用科室",
        key: "applyDeptName",
        width: 80
      },
      {
        label: '领用人',
        key: 'applyUserName',
        width: 70
      },
      {
        label: '住院号',
        key: 'patientNo',
        width: 80
      },
      {
        label: "患者姓名",
        key: "patientName",
        width: 80
      },
      {
        label: "医生工号",
        key: "doctorUserName",
        width: 80
      },
      {
        label: "医生姓名",
        key: "doctorUserNo",
        width: 80
      },
      {
        label: "数量",
        key: "totalNumber",
        width: 60
      },
      {
        label: "金额",
        key: "totalAmount",
        width: 60
      },
      {
        label: "备注",
        key: "remark",
      },
      ],
      isAutoCreateDeptInStock:0,
      isPicking: false
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    }else if(query.acceptInId){
      this.getAcceptInStock(query.acceptInId)
    }else if(query.outboundId){
      this.getPickingStock(query.outboundId)
    } else {
      this.handleAdd();
      if (query.applyId) {
        this.purchaseChange(query.applyId)
      }
    }
    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards1()

    } else {
      this.getDepts("");
    }

    this.getPurchaseList('')
    this.getOneLevelWarehousesBySessionWarehouseId("");
    this.getOutStockCategorys('')
    this.getTabelList("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.getProductList('')
    },
    // 编辑
    handleUpdate (id) {
      return new Promise((resolve, reject) => {
      this.GetDataAction({
        id
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        resolve(res.returnData)
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.applyDetails = this.form.applyDetails
        // purchaseApplyNo
        this.initWorkFlowProperty(this.form);
        this.getProductList('')
        this.getWarehousesByDept()
      });
    });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        var fn = () => {
          var valdateResult = this.productDetailRepeatValidate(this.form.details)
          if (!valdateResult.flag) {
            this.$my_message(valdateResult.msg, 'warning')
            this.$store.dispatch('SetLoading',false)
            return;
          }

          //校验产品是否已过期
          var productPeriodValidate = this.checkProductOverdueValidate(this.form.details);
          if (!productPeriodValidate.flag) {
            const h = this.$createElement;
            let content = [];
            content.push(
              h(
                "p", `${productPeriodValidate.msg}`,
              )
            );
            content.push(
              h(
                "p", `是否继续？`,
              )
            );
            this.$confirm("提示", {
              title: "提示",
              type: "warning",
              customClass: "promptBox",
              showCancelButton: true,
              showConfirmButton: true,
              message: h("div", content),
            }).then(() => {
              this.Save();
            }).catch((e) => {
              throw new Error(productPeriodValidate.msg);
            });
          } else {
            this.Save();
          }
        }


        let fn1 = () => {
          if (this.system_setting.IsApplyOutCheckPlan == 1) {
            const now = new Date();
            let query = {
              deptId: this.form.applyDeptId,
              startDate: this.parseTime(new Date(now.getFullYear(), now.getMonth() - 1, 1), "{y}-{m}-{d}"),
              endDate: this.parseTime(new Date(now.getFullYear(), now.getMonth(), 0), "{y}-{m}-{d}")
            }

            CheckIsHavePurchasePlans(query).then(res => {
              if (res.returnData == 0 || !res.returnData) {
                this.$confirm(`【${this.form.applyDeptName}】（请领科室）上月未下采购计划，请确认是否继续出库？`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  fn()
                }).catch(() => {

                });
              } else {
                fn()
              }
            })
          } else {
            fn()
          }
        }
        let arr = []
        this.form.details.forEach(res => {
          if (res.isRfid!=null) {
            if (res.number - res.packNumber != 0) {
              arr.push(res)
            }
          }
        })
        if (arr.length != 0 && this.isAutoCreateDeptInStock == 1) {
          let msg = ''
          arr.forEach((k,i)=>{
            msg += `第${i + 1}行，产品：${k.productName} \n`;
          })
         
          const h = this.$createElement;
            let content = [];
            content.push(
              h(
                "p", `${msg}`,
              )
            );
            content.push(
              h(
                "p", `是否继续提交？审批通过后将无法赋码！`,
              )
            );
            this.$confirm("提示", {
              title: "提示",
              type: "warning",
              customClass: "promptBox",
              showCancelButton: true,
              showConfirmButton: true,
              message: h("div", content),
            }).then(() => {
              fn1()
          }).catch(() => {
            return
          });
        } else {
          fn1()
        }
      });
    },
    Save () {
      this.SaveDataAction(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
          if(this.$route.query.applyId){
            this.$router.push({
            name: "PurchaseApply", // module里的code
            params:  this.$route.params
          });
            return
        }
        // this.$router.push({ path: this.getMainPath(this.$route.path) });
        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
      }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        "warehouseId": '',
        warehouseName: '',
        warehouseManagerId: '',
        warehouseManagerName: '',
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        useUserName: '',
        applyDeptName: '',
        applyDeptId: '',
        "balanceStatus": 2,
        outStockCategoryId: '',
        outStockCategoryName: '',
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.applyDetails = []

    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.$route.query.applyId) {
        this.$route.params.pageIndex = 1
      }
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    goBack () {
      // 返回指定页
      let params = this.$route.params
      params.backAppointPage = 1
      if (this.$route.query.resouce != 1) {
        // 非请领单跳转打开的请领出库的界面
        this.$route.params.pageIndex = 1
      }
      
      if(this.isPicking){
        
        this.$router.push({
          name: "PickingStock", // module里的code
          params: params
      });
        return
      }
      this.$router.push({
        name: "PurchaseApply", // module里的code
        params: params
      });
    },

    // 明细表
    handleAddChildForm () {
      if (!this.form.warehouseId || this.form.warehouseId == '') {
        this.$my_message('请先选择库房', 'warning')
        this.getProductList('')
        return
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
 
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        refundNumber: 0,
        "price": 0,
        "amount": 0,
        "remark": "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    closeSelectDialog () {
      this.showSelectDialog = false
    },
    pushChildForm (close) {
      let result = true
      console.log(this.childForm)
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        } else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          } else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
    },
    openScanner (ev) {
      if (!this.form.warehouseId || this.form.warehouseId == "") {
        this.$my_message("请先选择库房", 'warning');
        return;
      }
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;
      ev.target.blur();
    },
 getAcceptInStock(val){
      GetAcceptInStockById({id:val}).then(res=>{
         this.resetForm()
         this.editMode = true;
         this.form.category = res.returnData.category
          this.form.acceptInId = this.$route.query.acceptInId
         GetPurchaseDistributionById({id:res.returnData.distributionId}).then(r=>{
          this.form.warehouseId = r.returnData.oneLevelWarehouseId
          this.form.warehouseName = r.returnData.oneLevelWarehouseName
          this.form.warehouseManagerName = r.returnData.oneLevelWarehouseManagerName
          this.form.warehouseManagerId = r.returnData.oneLevelWarehouseManagerId
          this.form.applyDeptId = r.returnData.deptId
          this.form.applyDeptName = r.returnData.deptName
          let arr = JSON.parse(JSON.stringify(res.returnData.details))
            const mergedDetails = {};
            arr.forEach(item => {
              // 创建唯一标识键，组合所有需要比较的字段
              const key = [
                item.traceNo || '',
                item.mainNo || '',
                item.validityDate || '',
                item.manufactureDate || '',
                item.batch || '',
                item.serialNo || ''
              ].join('-');
              
              if (mergedDetails[key]) {
                // 如已存在相同键，累加数量
                mergedDetails[key].number += item.number;
                mergedDetails[key].amount = (mergedDetails[key].number * item.price).toFixed(4) * 1
                mergedDetails[key].tagCodeViewModels = mergedDetails[key].tagCodeViewModels.concat(item.tagCodeViewModels)
                 mergedDetails[key].itemTagCodeViewModels = mergedDetails[key].itemTagCodeViewModels?.concat(item.itemTagCodeViewModels)
                
              } else {
                // 如不存在，创建新条目
                mergedDetails[key] = { ...item, number: item.number };
              }
            });
            arr = Object.values(mergedDetails);
          this.form.details =  arr.map(val=>{
              GetSupplierProductById({id:val.supplierProductId}).then(i=>{
                  val.isScanName = i.returnData.isScan==1?'是':'否'
                  val.supplierName = i.returnData.supplierName
                  val.supplierId =  i.returnData.supplierId
                  val.refundNumber = 0
               
               
              })
              //
              return val
            })
            this.$nextTick(()=>{
              this.autoTotalAmount()
            })
         })
       
       
      })
    },
    // change event
    purchaseChange (val,bool) {
      GetApplyOutStocks({
        purchaseApplyId: val
      }).then(res => {
        if (res.returnData.totalCount > 0) {
          const h = this.$createElement
          let content = [h('p', '该请领单已做过请领出库')]
          res.returnData.data.forEach(item => {
            content.push(h('p', {
              style: 'color:red'
            }, `${item.no}`))
          });
          content.push(h('p', '请确认是否继续，若已完成，请终止请领单'))
          this.$confirm('提示', {
            title: '提示',
            type: 'warning',
            message: h('div', content)
          })
            .then(() => { })
            .catch(res => {
              if (res == 'cancel') {
                this.resetForm()
              }
            })
        }
      }).then(res => {
        GetPurchaseApplyById({
          id: val
        })
          .then(res => {
            if (res.successful) {
              let data = res.returnData
              this.form.purchaseApplyNo = data.no
              this.form.purchaseApplyId = data.id
              this.form.applyWarehouseId = data.warehouseId
              this.form.applyWarehouseManagerId = data.warehouseManagerId
              this.form.applyDeptName = data.applyDeptName
              this.form.applyDeptId = data.applyDeptId
              this.form.warehouseId = data.oneLevelWarehouseId
              this.form.warehouseName = data.oneLevelWarehouseName
              this.form.warehouseManagerId = data.oneLevelWarehouseManagerId
              this.form.warehouseManagerName = data.oneLevelWarehouseManagerName
              this.form.wardId = data.wardId
              this.form.remark = data.remark
              this.applyDetails = data.details
              this.form.distributionPoint = data.distributionPoint
              if(!bool){
                this.getAutoStocks()
              }
              
              this.getLocations(this.form.warehouseId)
              this.getWarehousesByDept()
            } else {
              this.form.purchaseApplyNo = ''
              this.form.purchaseApplyId = ''
              this.form.applyWarehouseId = ''
              this.form.applyWarehouseManagerId = ''
              this.form.applyDeptName = ''
              this.form.applyDeptId = ''
              this.form.warehouseId = ''
              this.form.warehouseName = ''
              this.form.warehouseManagerId = ''
              this.form.warehouseManagerName = ''
              this.applyDetails = []
            }

            this.getProductList('')
            
          })
      })

    },
    locationChange (row) {
      row.locationId = row.locationName
    },
    childLocationChange (val) {
      this.childForm.locationId = val
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_OneLevelWarehouses.filter(item => item.id == val)
      if (arr) {
        this.form.warehouseName = arr[0].name
        this.form.warehouseManagerId = arr[0].managerId
        this.form.warehouseManagerName = arr[0].managerName
      }

      this.getAutoStocks()
      this.getLocations(val)
      this.getProductList('');
    },
    getWarehousesByDept(){
      if (this.system_setting.IsUseWard) {
       GetWarehousesByDeptIdAndWard({deptIdAndWardIdGroup:`${this.form.applyDeptId}${ this.form.wardId?'-'+this.form.wardId:''}`}).then(res=>{
        this.isAutoCreateDeptInStock = res.returnData.isAutoCreateDeptInStock
        this.form.applyWarehouseId =  res.returnData.idGroup
       })
      }else{
        GetWarehousesByDeptId({deptId: this.form.applyDeptId}).then(res=>{
        if(res&&res.returnData){
          this.isAutoCreateDeptInStock = res.returnData.isAutoCreateDeptInStock
          this.form.applyWarehouseId =  res.returnData.id
        }      
      })
      }

      
      
    },
    // 
    applyDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards1.filter(res => res.idGroup == val)
      this.form.applyDeptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.applyDeptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getWarehousesByDept()
    },
    applyDeptChange (val) {
      this.form.applyDeptId = val
      this.getWarehousesByDept()
    },
    productChange (row) {
      let id = this.childForm.id
      this.childForm = Object.assign(this.childForm, row)
      this.childForm.id = id
      this.childForm.stockId = row.id
      this.childForm.number = 1

      this.childForm.amount = this.childForm.price
      // this.childForm.supplierProductNo = this.childForm.supplierProductNo
      this.childForm.remark = ''

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },
    handleCheckChange (node) {
      this.form.outStockCategoryId = node.id;
      this.form.outStockCategoryName = node.name;
    },

    handleMoveLiBrayInfo (row) {
      this.showSelectDialog = true;
      this.tipColumOptions = []
      this.tipColumOptions.push({
        name: "产品名称",
        code: 'productName',
        value: row.productName
      })
      this.tipColumOptions.push({
        name: "规格型号",
        code: 'specName',
        value: row.specName
      })
      this.tipColumOptions.push({
        name: "生产厂家",
        code: 'manufacturerName',
        value: row.manufacturerName
      })
      this.tipColumOptions.push({
        name: "批次号",
        type: 'select',
        code: 'batch',
        value: row.batch
      })
      this.tipColumOptions.push({
        name: "数量",
        code: 'number',
        value: row.number
      })
      this.tipColumOptions.push({
        name: "已移库数量",
        code: 'shareNumber',
        value: row.shareNumber
      })
      GetMoveLibraryByDetailId({
        id: row.id,
        type: 1
      })
        .then(res => {
          this.movelibrayList = res.returnData
        })

      console.log(this.movelibrayList, "this.movelibrayList");
    },

    getProductList (keyWord) {
      let supplierProductIds = []
      if (this.selectApplyArr) {
        supplierProductIds = this.selectApplyArr.map((item) => item.supplierProductId);
      }

      // query.pageIndex = 1
      // query.pageSize = 100
      // query.category = 0
      // query.warehouseId = this.form.warehouseId
      // query.applyId = this.form.purchaseApplyId
      // query.supplierProductIds = supplierProductIds

      let query = {
        pageIndex: 1,
        pageSize: 100,
        keyWord: keyWord,
        category: 0,
        warehouseId: this.form.warehouseId,
        applyId: this.form.purchaseApplyId,
        supplierProductIds: supplierProductIds
      }

      this.getStocks(query)
    },
    getAutoStocks () {
      this.form.details = []

      if (!this.form.warehouseId || !this.form.purchaseApplyId) {
        return
      }

      let query = {
        userId: this.userInfo.id,
        category: 0,
        warehouseId: this.form.warehouseId,
        applyId: this.form.purchaseApplyId,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId()
      }
      GetStockViewModelsByApplyId(query)
        .then(res => {
          if (res.returnData) {
            res.returnData.map((item, index) => {
              // var stock = this.mapper.Stock2Form({}, item)
              var stock = Object.assign({}, item) // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
              stock.id = 0
              stock.stockId = item.id

              stock.number = item.stockQuantity
              stock.amount = item.amount
              this.form.details.push(stock)
            })

            this.autoTotalAmount();
          }
        })
    },
    getPurchaseList (keyWord) {
      GetPurchaseApplys({
        no: keyWord,
        pageIndex: 1,
        pageSize: 100,
        status: 2,
        state: 0,
        warehouseId: this.mySessionStorage.getWarehouseId(),
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId()
      })
        .then(res => {
          this.purchaseList = res.returnData.data
        })
    },
    // getWarehouseList (keyWord) {
    //   if (this.form.applyDeptId) {
    //     this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.applyDeptId)
    //   }
    //   else {
    //     this.STATIC_OneLevelWarehouses = []
    //   }
    // },
    getPickingStock(id){
      this.editMode = true
      this.isPicking = true
      GetPickingStockById({
        id
      }).then(res => {
        if (res.returnData) {
          let data = res.returnData
            this.purchaseChange( data.applyStockAndDetailIds.split(';')[0],true)
          this.$nextTick(()=>{
            this.resetForm()
              this.form.applyDeptName = data.applyDeptName
            this.form.applyDeptId =  data.applyDeptId
            this.form.pickingStockNo = data.no
            this.form.warehouseId = data.warehouseId
            this.form.warehouseName = data.warehouseName
            this.form.pickingStockId = id
            this.form.purchaseApplyNo = data.purchaseApplyNo
            this.form.purchaseApplyId = data.applyStockAndDetailIds.split(';')[0]
            
            this.getWarehousesByDept()
            this.form.category = 0 
            this.form.details = data.details
            this.autoTotalAmount()
            this.$forceUpdate()
          })
        
        }
      })
    },
    selectApplyDetail (val) {
      this.selectApplyArr = val
      this.getProductList({})
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
<style>
.promptBox .el-message-box__message p {
  white-space: pre-wrap;
}
</style>